const fileInputs = document.querySelectorAll('input[type="file"]');

fileInputs.forEach((input) => {
    input.addEventListener('change', () => {
        const selectedFile = input.files[0];
        const parentDiv = input.parentNode;
        if (selectedFile) {
            const fileName = selectedFile.name;
            parentDiv.setAttribute('data-file-name', fileName);
        } else {
            parentDiv.removeAttribute('data-file-name');
        }
    });
});